import React, { forwardRef } from "react";
import classes from "./About.module.scss";

const techStack = "HTML5, CSS3, Tailwind CSS, Shadcn, MUI, JavaScript, TypeScript, SASS, React, Vue, Next.JS, Nuxt, Redux, Node.JS, Express, Nest.JS, MongoDB, SQL, PostgreSQL, TypeORM, Prisma, REST, GraphQL, Firebase, Serverless Architecture, GCP, AWS, GIT, JAMstack, Gatsby, Headless CMS, Webflow, Airtable, WordPress, Bootstrap, JQuery, JQuery Mobile, Postman, Jest, React Native, Expo".split(',');

const ExperienceItem = (props) => {
  return (
    <div className={classes.experience_item}>
      <a
        href={props.url}
        target="_blank"
        rel="noreferrer noopener"
        className={classes.link}
      >
        {props.title} <span>{`>>`}</span>
      </a>
      <p>{props.details}</p>
      <p className={classes.year}>{props.start} - {props.end}</p>
    </div>
  )
}

const About = forwardRef((_props, ref) => {
  return (
    <div className={classes.container}>      
      <div className={classes.content}>
          <h1><span>SOFTWARE</span> <span className={classes.desc_2}>ENGINEER</span></h1>
        <p>
          Hi! I'm  Tolulope, a detail-oriented software engineer. I have about <span className={classes.whiteText}>nine years</span> of experience building scalable, high-performance web applications across the stack with JavaScript, TypeScript, React, Vue, Next.js, Nuxt, Node.js, Express, PostgreSQL amongst other technologies. I have a proven track record of leading engineering initiatives, making architectural decisions, and delivering measurable business impact, including revenue growth and significant UX improvements. For formal education, I have a Bachelor of Science in Psychology. 
        </p>

        <p>
          I'm based in Lagos, Nigeria. However, location doesn't hinder my work as I have over eight years of experience working remotely with individuals and cross-functional teams in various countries across multiple time zones.
        </p>

        <h2 className={classes.tools}>Technologies and Tools</h2>
        {techStack.map(techName => <h3 className={classes.tech}>{techName}</h3>)}
      </div>

      <div className={classes.experience} ref={ref}>
        <h1><span>9 YEARS OF</span> <span className={classes.desc_2}>EXPERIENCE</span></h1>
        <ExperienceItem
          title="Squared Ace Solutions"
          url="https://www.linkedin.com/company/11036120"
          details="Proposed and led the migration of a major client’s high-traffic website from WordPress to React, resulting in a significantly improved UI/UX and over 50% increase in client revenue. I designed and implemented scalable frontend architectures using TypeScript, React, Vue, Next.js and Redux, ensuring maintainability and performance across multiple client projects. I also collaborated in delivering resilient backend systems using Node.js, Express and PostgreSQL, strengthening API performance, error handling, and service stability."
          start="Sep 2024"
          end="Present"
          />    
        <ExperienceItem
          title="Formula Monks (TheoremOne)"
          url="https://www.linkedin.com/company/46926"
          details="Spearheaded the frontend development of a large-scale commercial web application, consolidating four different apps into one unified platform, significantly improving user experience and maintainability. This required collaboration with cross-functional teams. I also implemented effective custom react hooks that reduced code duplication and improved performance across core application features."
          start="Oct 2022"
          end="Jul 2024"
          />
          <ExperienceItem
          title="Bejamas"
          url="https://www.linkedin.com/company/18595719"
          details="Implemented custom checkout requirements for a client project which led to a significantly better user experience in the checkout and order pages. I also developed user interfaces for websites and apps by coding to strict design specifications while working majorly with JavaScript, TypeScript, React, Vue, NextJS and Redux in an agile environment."
          start="Sep 2021"
          end="Aug 2022"
          />    
          <ExperienceItem
          title="Squared Ace Solutions"
          url="https://www.linkedin.com/company/11036120"
          details="Collaborated with stakeholders and the design/UX team to effectively translate business requirements into deliverables for the frontend team. This helped us focus better on shipping quality products. I partnered with cross-functional teams to design and deliver backend systems using Node.js, Express and MongoDB to significantly increase performance and reliability. I also worked on projects using react, wordpress and static websites using HTML5, CSS3, Javascript, Typescript, JQuery and bootstrap."
          start="Apr 2017"
          end="Aug 2021"
          />             
      </div>
    </div>
  );
});

export default About;
